<template>
  <section class="dateSelectorMeetings">
    <b-field :label="label">
      <b-datepicker
        v-model="computedValue"
        ref="datepicker"
        placeholder="Select Date"
        :min-date="minDateObject"
        :max-date="maxDateObject"
        :focused-date="focusedDate"
        :events="events"
        indicators="bars"
        @input="handleInput"
        :mobileNative="false"
        :nearby-selectable-month-days="true"
      >
        Meeting days are marked above.
      </b-datepicker>
    </b-field>
  </section>
</template>

<script>
import { initial } from "underscore";

var moment = require("moment");
Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

export default {
  name: "DateSelectorMeetings",
  data() {
    return {
      initialValue: this.determineInitialValue(),

    };
  },
  props: {
    value: {},
    label: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "departure",
    },
    minDate: {},
    maxDate: {},
  },
  methods: {
    toggle() {
      this.$refs.datepicker.toggle();
    },
    handleInput(value) {
      const validValue = this.getValidDateWithinRange(value);
      this.computedValue = validValue; // This will trigger the setter
    },
    getValidDateWithinRange(date) {
      const minDate = moment(this.minDate).startOf('day').toDate();
      const maxDate = moment(this.maxDate).startOf('day').toDate();
      if (date < minDate) return minDate;
      if (date > maxDate) return maxDate;
      return date;
    },
    determineInitialValue() {
      const minDate = moment(this.minDate).startOf('day').toDate();
      const maxDate = moment(this.maxDate).startOf('day').toDate();
      
      // Determine the initial value based on the type
      if (this.type === 'departure') {
        return this.getValidDateWithinRange(minDate);
      } else if (this.type === 'return') {
        return this.getValidDateWithinRange(maxDate);
      } else {
        return this.getValidDateWithinRange(new Date()); // Fallback to today's date
      }
    },
    updateComputedValue(emitEvent = false) {
      // Decide which date to use based on the type
      const targetDate = this.type === 'departure' ? this.minDateObject : this.maxDateObject;
      const validValue = this.getValidDateWithinRange(this.value || targetDate);
      
      if (this.computedValue !== validValue) {
        this.computedValue = validValue;
        if (emitEvent) {
          this.$emit("input", validValue);
        }
      }
    },
  },
  watch: {
  value(newVal) {
    const validValue = this.getValidDateWithinRange(newVal || this.initialValue);
    if (this.computedValue !== validValue) {
      this.computedValue = validValue;
    }
  },
  minDate() {
    this.updateComputedValue();
  },
  maxDate() {
    this.updateComputedValue();
  },
  type(newType) {
      this.updateComputedValue(true);
    },

  
},
mounted() {
  this.updateComputedValue(true);
},
  computed: {
    computedValue: {
      get() {
        return this.getValidDateWithinRange(this.value || this.initialValue);
      },
      set(value) {
        this.$emit("input", this.getValidDateWithinRange(value));
      },
    },
    minDateObject() {
      return moment(this.minDate)
        .startOf("day")
        .toDate();
    },
    maxDateObject() {
      return moment(this.maxDate)
        .startOf("day")
        .toDate();
    },
    focusedDate() {
      return this.minDateObject;
    },
    events() {
      var startMeeting = new Date(
        this.$store.state.meetings.meetingInfo.meeting.meetingStartDate
      );
      var endMeeting = new Date(
        this.$store.state.meetings.meetingInfo.meeting.meetingEndDate
      );
      var days = [];
      var i = startMeeting;
      while (i <= endMeeting) {
        i = i.addDays(1);
        days.push(i);
      }
      return days;
    },
  },
};
</script>

<style scoped></style>
